import { render, staticRenderFns } from "./PeixunshiMemberList.vue?vue&type=template&id=a2364bcc&scoped=true&"
import script from "./PeixunshiMemberList.vue?vue&type=script&lang=js&"
export * from "./PeixunshiMemberList.vue?vue&type=script&lang=js&"
import style0 from "./PeixunshiMemberList.vue?vue&type=style&index=0&id=a2364bcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2364bcc",
  null
  
)

export default component.exports